import { InstituteAddress, InstituteEmail, InstitutePhone, InstituteRoomBadge } from "@/apiGenerate/medserver";

export interface WaitingRoom {
    roomId: string;
    name: string;
    street: string;
    liveRoomDetails?: string;
    byDefault?: boolean;
    addressId: string;
    instituteId?: string;
    roomBadgeId?: string | null;
    roomBadge?: InstituteRoomBadge;
}

export interface Address {
    street: string;
    addressId: string;
}

export interface WaitingRoomForm {
    roomId: string;
    addressId: string;
    name: string;
    isEditing: boolean;
    byDefault: boolean;
    roomBadgeId: string | null;
}

export enum InstituteRoleType {
    HealthProGroup = "HealthProGroup", 
    HealthInsurance = "HealthInsurance", 
    HealthProLicense = "HealthProLicense", 
    LearningAccreditator = "LearningAccreditator", 
    LearningProvider = "LearningProvider",
    Catering = "Catering", 
    ConferenceRooms = "ConferenceRooms"
}

export interface Institute {
    instituteWithRoleId: string;
    instituteShortName: string;
    instituteRole: string;
    instituteName: string;
    customLine1: string
    customLine2: string;
    fastPatientCreationActive: boolean;
    official: boolean;
    ophthalmoDashboardActive: boolean;
    pidActive: boolean;
    emails: InstituteEmail[];
    addresses: InstituteAddress[];
    phones: InstitutePhone[];
}

export const InstituteErrorCode = {
    INSTITUTE_SLUG_ALREADY_EXISTS: 'INSTITUTE_SLUG_ALREADY_EXISTS'
} as const;